import { RootState } from 'store/store';

/**
 * Returns true if the journey has any SMS nodes.
 * Used to conditionally mount SMSSidePanel and avoid unnecessary template fetches.
 */
export function selectHasSMSNodes(teState: RootState['te']): boolean {
  return (teState.sms.allRefId?.length ?? 0) > 0;
}
